import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './OpinionSurvey.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Form from 'react-bootstrap/Form';
import { Link,useNavigate } from 'react-router-dom';
import {validateopinionsurvey} from '../../../Utils/validate';

const OpinionSurvey = () => {
    const navigate = useNavigate();

    const [inputss,setInputss] = useState({question:'',poll_expiry:''});

    const [errors,setErrors] = useState({});

    useEffect(() => {
        document.title = `Opinion Survey | Local Bells`;
        document.getElementById('bodywrap').className = 'neopisur';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const [images, setImages] = useState([]);

    // Handle files dropped or selected
    const handleFiles = (files) => {
        const imageFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
        const newImages = imageFiles.map(file => ({
            file,
            url: URL.createObjectURL(file),
        }));
        setImages(prev => [...prev, ...newImages]);
    };

    // Handle drag events
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = e.dataTransfer.files;
        handleFiles(files);
    };

    

    const handleDelete = (urlToRemove) => {
        setImages(prev => {
            const updated = prev.filter(img => img.url !== urlToRemove);
            URL.revokeObjectURL(urlToRemove); // Clean up memory
            return updated;
        });
    };


    const [inputs, setInputs] = useState([]);

    const handleChange = (index, event) => {
        const newInputs = [...inputs];
        newInputs[index] = event.target.value;
        setInputs(newInputs);
    };

    const handleAdd = () => {
        setInputs([...inputs, ""]);
    };

    const handleRemove = (index) => {
        const newInputs = inputs.filter((_, i) => i !== index);
        setInputs(newInputs);
    };
    const handleInputChangeimg = (e) => {
        handleFiles(e.target.files);
    };
    /* Start Value set */
    const handleInputChange = (event) => {
      event.persist();
      setInputss(inputss => ({...inputss, [event.target.name]: event.target.value}));       
    }
    /* End Value set */
    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validateopinionsurvey(inputss,images,inputs);
     const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
            navigate('/neighbour/local-dashboard');
        } 
    };    

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={10} lg={10} xl={6} xxl={6}>

                                        <div className='white-box opsur-box'>
                                            
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3>Opinion Survey</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            <h6>Seek neighborhood opinion on topics like Local business, government policies, Real estate, Local problems, Health & wellness Festivals and many more</h6>
                                            <Form onSubmit={handleSubmit}>
                                                <div className=''>
                                                    {/* Dropzone */}
                                                    <div
                                                        onDrop={handleDrop}
                                                        onDragOver={(e) => e.preventDefault()}
                                                        onDragEnter={(e) => e.preventDefault()}
                                                        className='gen-upload'

                                                    >
                                                        <input
                                                            type="file"
                                                            multiple
                                                            accept="image/*"
                                                            onChange={handleInputChangeimg}
                                                            id="fileInput"
                                                        />
                                                        <label htmlFor="fileInput">
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/uploadicn.webp'} className="img-fluid" alt="uploadicn" />
                                                            <div>
                                                                <h6>Upload Image</h6>
                                                                <h6><span className='fw-600'>420 X 270</span> px</h6>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    {errors.images && (<p className="text-danger">{errors.images}</p>)}
                                                    {/* Previews */}
                                                    <div className='gen-upload-preview'>
                                                        {images.map((img, index) => (
                                                            <div key={index} >
                                                                <img
                                                                    src={img.url}
                                                                    alt="preview"
                                                                />
                                                                <button
                                                                    onClick={() => handleDelete(img.url)}
                                                                    type='button'
                                                                >
                                                                    &times;
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Type your Question here</Form.Label>
                                                    <Form.Control as="textarea" rows={4} placeholder='Type your Question here' name="question" onChange={handleInputChange} value={inputss.question} />
                                                    {errors.question && (<p className="text-danger">{errors.question}</p>)}
                                                </Form.Group>
                                                <Form.Select aria-label="Default select example" name="poll_expiry" onChange={handleInputChange} value={inputss.poll_expiry}>
                                                    <option value="">Select poll expiry</option>
                                                    <option value="7">7 days</option>
                                                    <option value="14">14 days</option>
                                                    <option value="21">21 days</option>
                                                    <option value="30">30 days</option>
                                                </Form.Select>
                                                {errors.poll_expiry && (<p className="text-danger">{errors.poll_expiry}</p>)}
                                                <div className='opsur-repeter'>
                                                    {inputs.map((value, index) => (
                                                        <div key={index}>
                                                            <input
                                                                type="text"
                                                                value={value}
                                                                onChange={(e) => handleChange(index, e)}
                                                                placeholder={`Option ${index + 1}`}
                                                                className='form-control mb-3'
                                                            />
                                                            <Button onClick={() => handleRemove(index)} className='mb-3 red-btn opsur-del' type="button">
                                                                Delete
                                                            </Button>
                                                        </div>
                                                    ))}
                                                    
                                                    <Button onClick={handleAdd} className='blue-btn mb-5' type="button">Add +</Button>
                                                    {errors.option && (<p className="text-danger">{errors.option}</p>)}
                                                </div>
                                                <Button type="submit" className='blue-btn'>Post anonymous</Button>
                                            </Form>
                                        </div>

                                        <div className='red-note'>
                                            <h6>Terms and conditions: Users must follow respectful communication guidelines. Hate speech, harassment, and misinformation are prohibited, and may result in content removal or account suspension</h6>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                   
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default OpinionSurvey;


